<template>
  <Modal
    v-model="visible"
    :title="title"
    :width="900"
    class="asset_modal"
    :styles="{ top: '100px' }"
  >
    <Form
      ref="formDynamic"
      :model="formDynamic"
      :label-width="10"
      :rules="ruleValidate"
    >
      <Row>
        <Col :span="3" style="text-align: right; padding-top: 5px">
          <font style="color: red">*</font>Project Name
        </Col>
        <Col :span="21">
          <div
            v-for="(item, index) in formDynamic.NameList"
            :key="index"
            style="position: relative"
            ref="NameList"
          >
            <Row>
              <Col :span="12">
                <FormItem
                  :prop="'NameList.' + index + '.email'"
                  :rules="{
                    required: true,
                    message: 'item email can not be empty',
                    trigger: 'blur',
                  }"
                >
                  <Select
                    v-model="item.email"
                    placeholder="Please enter user email"
                    ref="selectt"
                    :disabled="disabled"
                    clearable
                    filterable
                    :remote-method="
                      (e) => {
                        return remoteMethod(e, index);
                      }
                    "
                    @on-select="(e) => handleChange(e, index)"
                  >
                    <Option
                      v-for="(it, inds) in item.SuperAdminUsers"
                      :key="inds"
                      :value="it.userId"
                      >{{ it.email }}</Option
                    >
                  </Select>
                </FormItem>
              </Col>
              <Col :span="11">
                <FormItem
                  :prop="'NameList.' + index + '.projectId'"
                  :rules="{
                    required: true,
                    message: 'item projectId can not be empty',
                    trigger: 'blur',
                  }"
                >
                  <Select
                    v-model="item.projectId"
                    placeholder="Please enter project"
                    @on-select="(e) => handleChangePro(e, index)"
                    ref="selects"
                    clearable
                    :disabled="disabled"
                  >
                    <Option
                      v-for="(it, inds) in item.Enterprise"
                      :key="inds"
                      :value="it.id"
                      >{{ it.name }}</Option
                    >
                  </Select>
                </FormItem>
              </Col>
            </Row>
            <span
              style="
                position: absolute;
                right: 0;
                top: 0px;
                font-size: 20px;
                cursor: pointer;
              "
              @click="deleteUser(index)"
              v-if="formDynamic.NameList.length > 1 && index > 0"
              ><Icon type="ios-remove-circle-outline"
            /></span>
          </div>
        </Col>
      </Row>
      <Row>
        <Col :span="3"> </Col>
        <Col :span="21">
          <Button
            icon="ios-add"
            @click="handleAdd"
            style="margin-left: 10px; margin-bottom: 15px"
            :disabled="disabled"
            >Add project</Button
          >
        </Col>
      </Row>
      <Row>
        <Col :span="3" style="text-align: right; padding-top: 5px"
          ><font style="color: red">*</font>Email Suffix</Col
        >
        <Col :span="21">
          <FormItem prop="emailSuffix">
            <Select
              v-model="formDynamic.emailSuffix"
              :disabled="disabled"
              filterable
              multiple
              allow-create
              @on-create="handleCreate"
              :not-found-text="'12'"
            >
              <Option
                v-for="item in emailSuffixs"
                :value="item.value"
                :key="item.value"
                >{{ item.label }}</Option
              >
            </Select>
          </FormItem>
        </Col>
      </Row>
      <Row>
        <Col :span="3" style="text-align: right; padding-top: 5px">Active</Col>
        <Col :span="21">
          <FormItem prop="isDelete">
            <i-switch
              v-model="formDynamic.isDelete"
              :disabled="disabled"
            ></i-switch>
          </FormItem>
        </Col>
      </Row>
    </Form>
    <div slot="footer">
      <Button @click="handleCancel">Cancel</Button>
      <Button
        @click="handleSave"
        type="primary"
        :loading="loadingActive"
        :disabled="disabled"
        >Confirm</Button
      >
    </div>
  </Modal>
</template>
<script>
import apiRoutes from "@/config/API_ROUTER";

export default {
  data() {
    const validateEmail = (rule, value, callback) => {
      // console.log(value);
      if (
        !/@([A-Za-z\d]+[-.])+[A-Za-z\d]{2,4}$/.test(value[value.length - 1])
      ) {
        callback(new Error("Please enter the correct email format."));
      } else if (value.length > 20) {
        callback(new Error("Only 20 can be entered!"));
      } else {
        callback();
      }
    };
    return {
      visible: false,
      title: "Add Firm",
      type: "add",
      firmId: "", // 数据id
      SuperAdminUsers: [],
      emailSuffixs: [],
      arrlist: [],
      loadingActive: false,
      formDynamic: {
        NameList: [],
        emailSuffix: [],
        isDelete: true,
      },
      loading: false,
      userId: "",
      ids: 0,
      ruleValidate: {
        emailSuffix: [
          {
            required: true,
            message: "The emailSuffix cannot be empty",
            type: "array",
          },
          { validator: validateEmail, trigger: "change", type: "array" },
        ],
      },
      disabled: false,
      emailTest: "",
    };
  },
  created() {
    // this.getSuperAdminUsers()
  },
  mounted() {
    // this.$nextTick(() => {
    //   this.$on("openDialogs", function(type, record) {
    //     this.openDialog(type, record);
    //   });
    // });
  },
  methods: {
    // 打开弹窗
    openDialog(type, record) {
      this.visible = true;
      this.loadingActive = false;
      this.type = type;
      this.disabled = false;
      this.clearForm();
      if (type === "add") {
        this.title = "Add Firm";
        // 获取superAdminUser
        this.getSuperAdminUsers();
      } else if (type === "edit") {
        this.title = "Edit Firm";
        this.firmId = record.row.firmId;
        // 获取详情
        this.getDetail(record.row.firmId);
        // this.getSuperAdminUsers();
        // console.log(this.formDynamic);
      } else {
        this.title = "Look Firm";
        this.disabled = true;
        this.firmId = record.row.firmId;
        // 获取详情
        this.getDetail(record.row.firmId);
      }
    },
    // 获取详情
    getDetail(id) {
      const url = apiRoutes.FirmDetail;
      const params = {
        firmId: id,
      };
      this.$http.get(url, { params }).then((res) => {
        // console.log(res, "46454");
        const { data } = res.data;
        const { isSuccess } = res.data;
        if (isSuccess) {
          const arr = [];
          data.projects.forEach((item) => {
            const pro = {
              email: item.userId,
              projectId: item.projectId,
              SuperAdminUsers: [{ email: item.userEmail, userId: item.userId }],
              Enterprise: [{ id: item.projectId, name: item.projectName }],
            };
            arr.push(pro);
          });
          const email = [];
          const emailSuffix = data.emailSuffix.split(",");
          emailSuffix.forEach((item) => {
            const emailObj = {};
            emailObj.value = item;
            emailObj.label = item;
            email.push(emailObj);
          });
          this.emailSuffixs = email;
          const obj = {
            NameList: arr,
            emailSuffix,
            isDelete: data.isDelete === 0,
          };
          // console.log(obj, "22222");
          this.formDynamic = obj;
        }
      });
    },
    // 远程搜索邮箱
    remoteMethod(query, index) {
      this.loading = true;
      this.userId = query;
      this.$refs.selectt[index].query = query;
      if (query !== "" && this.flag) {
        this.flag = false;
        this.getSuperAdminUsers(query, index);
      }
    },
    // 项目选择
    handleChangePro(e, index) {
      const { email } = this.formDynamic.NameList[index];
      // console.log(email, "3112");
      const arr = this.formDynamic.NameList.filter((item) => {
        return item.email === email && item.projectId === e.value;
      });
      // console.log(arr, "31129");
      if (arr.length >= 1) {
        this.$Message.error("This item has been selected, please re-select");
        this.$refs.selects[index].clearSingleSelect();
      }
      // console.log(this.formDynamic.NameList, "45646");
    },
    // 邮箱选择
    handleChange(e, index) {
      const url = apiRoutes.Enterprise;
      const params = {
        userId: e.value,
      };
      this.$http
        .get(url, {
          params,
        })
        .then((res) => {
          const { data } = res.data;
          const { isSuccess } = res.data;
          if (isSuccess) {
            this.formDynamic.NameList[index].Enterprise = data;
          }
        });
    },
    // 获取邮箱
    getSuperAdminUsers(keyword, ids) {
      const index = ids || 0;
      const url = apiRoutes.SuperAdminUsers;
      const params = {
        keyword,
      };
      this.$http.get(url, { params }).then((res) => {
        const { data } = res.data;
        const { isSuccess } = res.data;
        if (isSuccess) {
          this.loading = false;
          this.$refs.selectt[index].clearSingleSelect();
          this.formDynamic.NameList[index].SuperAdminUsers = data;
          this.$set(this.formDynamic.NameList[index], "SuperAdminUsers", data);
        }
      });
    },
    // 新增project
    handleAdd() {
      if (this.formDynamic.NameList.length >= 20) return;
      this.ids += 1;
      const obj = {
        projectId: "",
        email: "",
        SuperAdminUsers: [],
        Enterprise: [],
        ids: this.ids,
      };
      this.formDynamic.NameList.push(obj);
      this.getSuperAdminUserStart();
    },
    // 删除
    deleteUser(index) {
      // console.log(1);
      const arr = this.formDynamic.NameList;
      arr.splice(index, 1);
      // console.log(arr, "626");
    },
    // 取初始值
    getSuperAdminUserStart() {
      const url = apiRoutes.SuperAdminUsers;
      const params = {
        keyword: "",
      };
      this.$http
        .get(url, {
          params,
        })
        .then((res) => {
          const { data } = res.data;
          const { isSuccess } = res.data;
          if (isSuccess) {
            this.loading = false;
            this.SuperAdminUsers = data;
            for (let i = 0; i < this.formDynamic.NameList.length; i += 1) {
              if (this.formDynamic.NameList[i].ids) {
                this.formDynamic.NameList[i].SuperAdminUsers =
                  this.SuperAdminUsers;
              }
            }
          }
        });
    },
    // 创建邮箱
    handleCreate(val) {
      this.$refs.formDynamic.validateField("emailSuffix");
      if (this.emailSuffixs.length >= 20) {
        return false;
      }
      this.emailSuffixs.push({
        value: val,
        label: val,
      });
      const obj = {};
      const newArr = this.emailSuffixs.reduce((cur, next) => {
        if (!obj[next.value]) {
          obj[next.value] = true;
          cur.push(next);
        }
        return cur;
      }, []);
      // console.log(newArr, "newArr");
      this.emailSuffixs = newArr;
      return true;
    },
    // 保存
    handleSave() {
      this.$refs.formDynamic.validate((valid) => {
        if (valid) {
          const { NameList, emailSuffix, isDelete } = JSON.parse(
            JSON.stringify(this.formDynamic)
          );
          const arr = [];
          NameList.forEach((item) => {
            arr.push(item.projectId);
          });
          const params = {
            projectIds: arr,
            emailSuffix: emailSuffix.join(","),
            isDelete: isDelete ? 0 : 1,
          };
          // console.log(params);
          // console.log(this.formDynamic, arr, "5645");
          const url = apiRoutes.Firm;
          this.loadingActive = true;
          if (this.type === "add") {
            this.$http
              .post(url, {
                ...params,
              })
              .then((res) => {
                // console.log(res, "89998");
                if (res.status === 200) {
                  this.$Message.success("Success!");
                  this.visible = false;
                  this.$emit("Success");
                } else {
                  // this.$Message.error("Fail!");
                }
                this.loadingActive = false;
              });
          } else if (this.type === "edit") {
            params.firmId = this.firmId;
            this.$http
              .put(url, {
                ...params,
              })
              .then((res) => {
                // console.log(res, "89998");
                if (res.status === 200) {
                  this.$Message.success("Success!");
                  this.visible = false;
                  this.$emit("Success");
                } else {
                  this.$Message.error("Fail!");
                }
                this.loadingActive = false;
              });
          }
        } else {
          // this.$Message.error("Fail!");
        }
      });
    },
    // 取消
    handleCancel() {
      this.visible = false;
      this.disabled = false;
    },
    // 清空表单
    clearForm() {
      this.$refs.formDynamic.resetFields();
      const arr = [];
      for (let i = 0; i <= 20; i += 1) {
        const obj = {
          projectId: "",
          email: "",
          SuperAdminUsers: [],
          Enterprise: [],
        };
        arr.push(obj);
      }
      this.formDynamic = {
        NameList: arr,
        emailSuffix: [],
        isDelete: true,
      };
      this.emailSuffixs = [];
      this.SuperAdminUsers = [];
      if (this.type === "add") {
        this.formDynamic.NameList.length = 1;
      }
    },
  },
};
</script>
<style lang="less" scoped>
/deep/ .ivu-form-item {
  margin-bottom: 18px !important;
}
/deep/ .ivu-form-item-error-tip {
  font-size: 13px !important;
  padding-top: 1px !important;
}

/deep/ .ivu-select-multiple .ivu-tag:nth-child(n + 21) {
  display: none;
}
</style>
